// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/bid_kind.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/bid_kind.proto.
 */
export const file_bfftypes_v1_bid_kind: GenFile = /*@__PURE__*/
  fileDesc("ChpiZmZ0eXBlcy92MS9iaWRfa2luZC5wcm90bxILYmZmdHlwZXMudjEqcQoHQmlkS2luZBIYChRCSURfS0lORF9VTlNQRUNJRklFRBAAEhAKDEJJRF9LSU5EX01JThABEhAKDEJJRF9LSU5EX01BWBACEhAKDEJJRF9LSU5EX1FUWRADEhYKEkJJRF9LSU5EX1FUWV9UT1RBTBAEQkJaQGdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnR5cGVzL3YxO2JmZnR5cGVzdjFiBnByb3RvMw");

/**
 * BidKind classifies the bid limit value type within a (segment, area,
 * side) triple. MIN / MAX are prices (円/kWh); QTY is quantity (MW),
 * applied per single bid (上限数量(1札)); QTY_TOTAL is also a quantity
 * (MW) but applied to the summed volume of every active bid sharing the
 * same (segment, area, koma, side) (上限数量(コマ計)). bid-limits.md §1-2
 * / mock-app/docs/domain-knowledge.md §4「入札の数量上限は「1 札上限」と
 * 「コマ計上限」の 2 統制に分ける」(2026-07-21 確定): the two are stored
 * as independent cell values, never sharing one number.
 *
 * Hosted under bfftypes/v1 so future bidding / 入札画面の BFF service が
 * 同じ enum を共有できる (= ytnsym 指摘 #3259242489)。
 *
 * @generated from enum bfftypes.v1.BidKind
 */
export enum BidKind {
  /**
   * @generated from enum value: BID_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BID_KIND_MIN = 1;
   */
  MIN = 1,

  /**
   * @generated from enum value: BID_KIND_MAX = 2;
   */
  MAX = 2,

  /**
   * 上限数量(1札)。 手動起票のみに適用するファットフィンガー防止ガード
   * (docs/specs/bidding/bid-limits.md §1-2)。
   *
   * @generated from enum value: BID_KIND_QTY = 3;
   */
  QTY = 3,

  /**
   * 上限数量(コマ計)。 同一(エリア×コマ×売買)の全札(手動+自動+ブロック)
   * 合計に対するサーキットブレーカー (bid-limits.md §1-2)。 QTY (1札) とは
   * 別統制のため独立した kind を持つ。
   *
   * @generated from enum value: BID_KIND_QTY_TOTAL = 4;
   */
  QTY_TOTAL = 4,
}

/**
 * Describes the enum bfftypes.v1.BidKind.
 */
export const BidKindSchema: GenEnum<BidKind> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_bid_kind, 0);

